import React from 'react'
import { profilePhoto } from '../../assets'

export default function Image({

}) {
  return (
    <div className="srh-profile-img">
      <img 
        src={profilePhoto}
      />
    </div>
  )
}